import { Component, HostListener, input, model } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'tvui-dialog',
    imports: [CommonModule],
    templateUrl: './dialog.component.html',
    styleUrl: './dialog.component.scss'
})
export class DialogComponent {
	closable = input(true);
	visible = model(false);

	@HostListener('document:keydown.Escape', ['$event'])
	doClose(event?: any) {
		if (this.closable()) {
			if (event && event instanceof PointerEvent) {
				if ((event as any).target.classList.contains('tvui-dialog--visible')) {
					this.close();
				}
			} else {
				this.close();
			}
		}
	}

	private close() {
		this.visible.set(false);
	}
}
